import {
  transformCohortData,
  transformDataTableData,
  transformExpressionData,
  transformFunnelData,
  transformPathData,
  transformPredictionData,
  transformRetentionData,
} from './';
import { IAnalysisResponse } from '../apollo/responseTypes';
import transformSignificanceData from './transformSignificanceData';

export default (analysis: IAnalysisResponse) => {
  switch (analysis.__typename) {
    case 'Expression':
      return transformExpressionData(analysis);
    case 'DataTable':
      return transformDataTableData(analysis);
    case 'Funnel':
      return transformFunnelData(analysis);
    case 'Retention':
      return transformRetentionData(analysis);
    case 'Path':
      return transformPathData(analysis);
    case 'Prediction':
      return transformPredictionData(analysis);
    case 'CohortSample':
      return transformCohortData(analysis);
    case 'Significance':
      return transformSignificanceData(analysis);
  }
};
